import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import {
  InvestigationGet,
  updateinvestigations,
  updatehospitalservices,
  sidebar_menu,
} from "../../text/apidata";
import "../style/page/investigation.scss";
import BasicTable from "../maincomponent/reacttable/table";
import { useEffect, useState, useMemo } from "react";
import Admin_access_form from "../form/Admin_access_form";
import axios from "axios";
import {
  Investigation,
  Investigationid,
  sidebar,
} from "../redux/reducer/counterslice";
import Swal from "sweetalert2";

export default function AdminAccess(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const investigationid = useSelector((state) => state.counter.Investigationid);
  const investigationstate = useSelector(
    (state) => state.counter.Investigation
  );
  const [isactivefilterdata, setisactivefilterdata] = useState("");

  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  let roledata = localStorage.getItem("role");

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        props.loaderchange("true");
        console.log(searchQuery);
        axios({
          method: "get",
          url: sidebar_menu,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            //   is_active: isactivefilterdata,
          },
        })
          .then((res) => {
            console.log(res);
            settableheaderdata(res.data.data.whole_data);
            setdatacount(res.data.data.data_count);
            props.loaderchange("false");
          })
          .catch((error) => {
            props.loaderchange("false");
          });
      }
    } else {
      props.loaderchange("true");
      console.log(searchQuery);
      axios({
        method: "get",
        url: sidebar_menu,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          //   search: searchQuery,
          //   is_active: isactivefilterdata,
        },
      })
        .then((res) => {
          console.log(res, "admin access");
          settableheaderdata(res.data.data.whole_data);
          setdatacount(res.data.data_count);
          props.loaderchange("false");
        })
        .catch((error) => {
          props.loaderchange("false");
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    investigationstate,
    isactivefilterdata,
  ]);
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };

  const dropdownhandlechange = (id, e) => {
    dispatch(Investigationid(id));
    dispatchid(Investigation("Edit"));
  };

  const creatfunction = () => {
    dispatchid(Investigation("Create"));
  };
  const columns = useMemo(
    () => [
      {
        Header: "Display Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.display_name}
              >
                {row.row.original.display_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Unique Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.unique_name}
              >
                {row.row.original.unique_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Display Order",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.display_order}
              >
                {row.row.original.display_order}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );
  const getdata = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updateinvestigations,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Has Been Upadated",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((error) => { });
      }
    });
  };
  const getdata2 = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updatehospitalservices,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Has Been Upadated",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((error) => { });
      }
    });
  };
  return (
    <>
      <div className={sideactive ? "investigation-sa" : "investigation"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Investigations</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Investigations</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div>
                    {/* {roledata=="Super Admin"&&<button className="getdata m-1" onClick={(e)=>{
                    getdata()
                  }}>
                    <div class="spinner">
                      <i class="bi bi-chevron-double-down"></i>
                    </div>
                    Update Investigation Data
                  </button>}
                                    {roledata=="Super Admin"&&<button className="getdata m-1" onClick={(e)=>{
                    getdata2()
                  }}>
                    <div class="spinner">
                      <i class="bi bi-chevron-double-down"></i>
                    </div>
                    Update Hospital Services Data
                  </button>} */}
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    isactive={false}
                    isactivefilterdata={isactivefilterdata}
                    setisactivefilterdata={setisactivefilterdata}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {investigationstate == "Edit" || investigationstate == "Create" ? (
        <Admin_access_form
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
    </>
  );
}
